module.exports = __webpack_public_path__ + "img/block_3.c6e51274.png";